import { BsBuilding, BsShieldLock } from "react-icons/bs"
import { CgNotes } from "react-icons/cg"
import { CiGrid42, CiSettings } from "react-icons/ci"
import { MdSecurity } from "react-icons/md"
import PeopleIcon from "@mui/icons-material/People"
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined"
import TrendingUpOutlinedIcon from "@mui/icons-material/TrendingUpOutlined"
import WarningAmberOutlinedIcon from "@mui/icons-material/WarningAmberOutlined"
import PowerOutlinedIcon from "@mui/icons-material/PowerOutlined"
import { ROUTE_PATHS } from "../../../utilities/constants"

const SidePanelConfig = ({
  userIsManager,
  userIsSponsor,
  userIsTrainer,
  userCanManageChildOrgs,
  userCanManageOrgs,
  hasIntegrations = false,
  hasKpi = false,
}) => [
  {
    type: "link",
    icon: <CiGrid42 />,
    text: "Dashboard",
    link: ROUTE_PATHS.DASHBOARD,
    activeLinks: ["/dashboard"],
    disabled: false,
    // Metrics are sponsor/manager scoped (matches the getOrgMetrics action roles)
    visible: !!(userIsSponsor || userIsManager),
  },
  {
    type: "link",
    icon: <BsShieldLock />,
    text: "Exercises",
    link: "/games",
    activeLinks: ["/games"],
    disabled: false,
    visible: true,
  },
  {
    // KPI P2 §13.3: the People directory (orgs with KPI_ANALYTICS).
    type: "link",
    icon: <GroupsOutlinedIcon style={{ fontSize: "1.1rem" }} />,
    text: "People",
    link: ROUTE_PATHS.PEOPLE,
    activeLinks: [ROUTE_PATHS.PEOPLE],
    disabled: false,
    visible: hasKpi === true && !!(userIsSponsor || userIsManager || userIsTrainer),
  },
  {
    // KPI P2 §13.4: a player's own results.
    type: "link",
    icon: <TrendingUpOutlinedIcon style={{ fontSize: "1.1rem" }} />,
    text: "My progress",
    link: ROUTE_PATHS.MY_PROGRESS,
    activeLinks: [ROUTE_PATHS.MY_PROGRESS],
    disabled: false,
    visible: hasKpi === true && !(userIsSponsor || userIsManager || userIsTrainer),
  },
  {
    type: "link",
    icon: <CgNotes />,
    text: "Scenarios",
    link: "/scenarios",
    // link: "/scenario/templates",
    activeLinks: ["/scenarios", "/scenario"],
    disabled: !(userIsManager || userIsSponsor || userIsTrainer),
    visible: userIsManager || userIsSponsor || userIsTrainer,
  },
  {
    type: "link",
    icon: <WarningAmberOutlinedIcon style={{ fontSize: "1.1rem" }} />,
    text: "Incidents",
    link: ROUTE_PATHS.INCIDENTS,
    activeLinks: [ROUTE_PATHS.INCIDENTS],
    disabled: false,
    // Hidden for now — Incident Management is a future feature. Flip to true to re-enable the tab.
    visible: false,
  },
  {
    // Section label (CT Modern rail) — replaces the old bare divider
    type: "label",
    text: "Admin",
    visible: userIsSponsor == true || userIsManager == true,
  },
  {
    type: "link",
    icon: <PowerOutlinedIcon style={{ fontSize: "1.1rem" }} />,
    text: "Integrations",
    link: ROUTE_PATHS.INTEGRATIONS,
    activeLinks: ["/integrations"],
    disabled: false,
    // Entitlement-gated: hidden unless the org (or a manager) is granted Integrations.
    visible: (userIsSponsor === true || userIsManager === true) && hasIntegrations === true,
  },
  {
    type: "link",
    icon: <CiSettings />,
    text: "Settings",
    link: "/settings",
    activeLinks: ["/settings"],
    excludeLinks: ["/settings/security"],
    // Settings routes by role via the /settings switchboard: Sponsors → Security
    // Exercise Settings (org-admin), Managers → tabbed Prompt Profiles settings.
    disabled: false,
    visible: userIsSponsor === true || userIsManager === true,
  },
  {
    type: "link",
    icon: <BsBuilding />,
    text: "Organizations",
    link: ROUTE_PATHS.ORGANIZATIONS,
    activeLinks: [ROUTE_PATHS.ORGANIZATIONS],
    // Partner orgs (and ChaosTrack managers) manage their child customers here.
    // Uses canManageOrgs (action=crud required) — excludes partner-trainers (CT7).
    disabled: !userCanManageOrgs,
    visible: userCanManageOrgs === true,
  },
  {
    type: "link",
    icon: <MdSecurity />,
    text: "Security",
    link: ROUTE_PATHS.SECURITY_SETTINGS,
    activeLinks: ["/settings/security"],
    disabled: !(userIsSponsor && !userIsManager),
    visible: userIsSponsor && !userIsManager,
  },
  {
    type: "link",
    icon: <PeopleIcon style={{ fontSize: "1.1rem" }} />,
    text: "User Management",
    link: ROUTE_PATHS.COMPANY_USER_MANAGEMENT,
    activeLinks: [ROUTE_PATHS.COMPANY_USER_MANAGEMENT],
    disabled: !userIsSponsor || userIsManager,
    visible: userIsSponsor == true && userIsManager == false,
  },
]

export default SidePanelConfig
